// the little "hide" tab every on-screen piece carries (see hudView.js)
import { toggle } from "./hudView.js";
import { say } from "../data/text.js";

export default function HideBtn({ id, className = "" }) {
  return (
    <button type="button" className={"hide-btn " + className} onClick={(e) => { e.stopPropagation(); toggle(id); e.currentTarget.blur(); }}
      title={`${say("view.hide")} — ${say("view.piece." + id)}`} aria-label={`${say("view.hide")} ${say("view.piece." + id)}`}>
      {say("view.hide")}
    </button>
  );
}
